/**
 * Convertit une chaîne en slug URL-friendly
 * Ex: "Café & Restaurant L'Étoile" -> "cafe-restaurant-etoile"
 */
export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Supprimer les accents
    .replace(/[^a-z0-9]+/g, '-') // Remplacer les caractères spéciaux par des tirets
    .replace(/^-+|-+$/g, '') // Supprimer les tirets au début et à la fin
    .replace(/-+/g, '-'); // Remplacer les tirets multiples par un seul
};

/**
 * Génère un slug unique en ajoutant un suffixe si nécessaire
 */
export const generateUniqueSlug = (
  name: string,
  existingSlugs: string[]
): string => {
  let slug = slugify(name);
  let counter = 1;

  // Si le slug existe déjà, ajouter un suffixe numérique
  while (existingSlugs.includes(slug)) {
    slug = `${slugify(name)}-${counter}`;
    counter++;
  }

  return slug;
};